import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export default function MarkingSchemeTable() {
  const rows = [
    { answerType: 'Correct Answer', marks: 'Four marks (+4)' },
    { answerType: 'Incorrect Answer', marks: 'Minus one mark (-1)' },
    { answerType: 'Unanswered', marks: 'No mark (0)' },
  ];

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 400 }} aria-label="marking scheme table">
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Answer Type</strong>
            </TableCell>
            <TableCell>
              <strong>Marks</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.answerType}>
              <TableCell>{row.answerType}</TableCell>
              <TableCell>{row.marks}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
